import { BinIcon } from "../../../../components/icon/Icon";
import { Button } from "react-bootstrap";
import { MobileAppAuthFingerprintIconContainerStyled } from "./styled/MobileAppAuthFingerprintStyled";
import classnames from "classnames";
import { MOBILE_APP_AUTH_STATE } from "../mobileAppAuthConstants";
import useEffectOnce from "../../../../hooks/useEffectOnce";
import { platformAuthenticatorIsAvailable } from "@simplewebauthn/browser";
import { useState } from "react";
import { Loader } from "../../../../components/Loader/Loader";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";

function MobileAppAuthFingerprint(props) {
    const {onSetupFingerprint, onSkipSetupFingerprint, state} = props;
    const isCreteFingerDone = state === MOBILE_APP_AUTH_STATE.CREATE_FINGER_DONE;
    const [isLoading, setIsLoading] = useState(true);
    const {getLangPath} = useLangContext();

    useEffectOnce(() => {
        platformAuthenticatorIsAvailable()
            .then(isAuthenticatorAvailable => {
                if (isAuthenticatorAvailable) {
                    setIsLoading(false);
                } else {
                    onSkipSetupFingerprint();
                }
            })
    });

    if (isLoading) {
        return <Loader show/>
    }

    return <div className="d-flex align-items-center justify-content-center h-100">
        <div className="d-flex flex-column w-100 px-3">
            <div className="d-flex justify-content-center">
                <MobileAppAuthFingerprintIconContainerStyled>
                    <BinIcon name="IcFingerprint" style={{fontSize: '80px'}}/>
                    {isCreteFingerDone &&
                        <BinIcon className="check-mark-icon" name="IcCheckMarkCircle" style={{fontSize: '40px'}}/>}
                </MobileAppAuthFingerprintIconContainerStyled>
            </div>
            <h1 className="text-center">
                {getLangPath(isCreteFingerDone ? "lite_version.sign_up.ready" : "lite_version.sign_up.fingerprint")}
            </h1>
            <div className={classnames("d-flex flex-column", {
                'visibility-hidden': isCreteFingerDone,
            })}>
                <p className="text-center f16 mt-1">{getLangPath('lite_version.sign_up.use_fingerprint')}</p>
                <Button className="mt-2rem" variant="primary" size="lg" onClick={onSetupFingerprint}>
                    {getLangPath('lite_version.sign_up.set_up')}
                </Button>
                <Button variant="outline-info" size="lg" className="mt-3" onClick={onSkipSetupFingerprint}>
                    {getLangPath('lite_version.sign_up.skip_button')}
                </Button>
            </div>
        </div>
    </div>
}

export default MobileAppAuthFingerprint;
